var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action",attrs:{"title":_vm.$t('buttons.info'),"aria-label":_vm.$t('buttons.info')},on:{"click":_vm.show}},[_c('i',{staticClass:"material-icons"},[_vm._v("info")]),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.info')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }